import '../styles/kpiCard.css';

export default function KpiCard({
  title,
  value,
  percentage,
  isUp,
  gradient,
  logo
}) {
  return (
    <div
      className={`
        relative rounded-xl shadow-lg text-white
        ${gradient}
        p-4 sm:p-5 md:p-6
        min-h-[120px]
        flex flex-col justify-between
      `}
    >
      {/* Menu */}
      <div className="absolute top-3 right-3 text-white/70 cursor-pointer text-lg">
        ⋮
      </div>

      {/* Title */}
      <div className="text-sm sm:text-base opacity-90">
        {title}
      </div>



      {/* Value + Percentage (ONE LINE ALWAYS) */}
    {/* Value + Percentage */}
      <div className="mt-1 flex items-center gap-2 whitespace-nowrap">
        <span className="text-xl sm:text-2xl md:text-3xl font-bold leading-tight">
          {value}
        </span>

        {isUp !== null && percentage && (
          <span
            className={`text-xs sm:text-sm font-medium ${
              isUp ? "text-green-200" : "text-red-200"
            }`}
          >
            {percentage} {isUp ? "↑" : "↓"}
          </span>
        )}
      </div>
      {logo && (
          <img 
            src={logo}
            alt="platform-logo"
            className="absolute bottom-4 right-4 w-9 h-9 object-contain opacity-00"
            />
        )}
    </div>
  );
}
